import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { BarTitle } from "../components/CollapseBar";
import TirSubeSummary from "../components/TirSubeSummary";
import { downloadFile } from "../lib/download";
import { TrendingUp, Download } from "lucide-react";

const tl = (n) => (Number(n) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });
const today = () => new Date().toISOString().slice(0, 10);

export default function GunlukKar() {
  const [date, setDate] = useState(today());
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/tir-daily", { params: { date } }).then((r) => setD(r.data)); }, [date]);
  const g = d?.genel;
  return (
    <div data-testid="gunluk-kar-page" className="mw-fade-up space-y-3">
      <BarTitle><h1 className="font-head flex items-center gap-2 text-2xl font-bold text-white"><TrendingUp className="h-6 w-6 text-emerald-400" /> GÜNLÜK KÂR ÖZETİ</h1></BarTitle>
      <div className="flex flex-wrap items-center gap-2 text-sm text-slate-300">
        TARİH <input data-testid="gk-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} className="h-9 rounded border border-slate-700 bg-slate-800 px-2 text-slate-100" />
        <span data-testid="gk-count" className="text-xs text-slate-400">{d?.tirs.length || 0} TIR</span>
        {g && <span data-testid="gk-genel-kar" className={`ml-auto rounded-lg px-3 py-1 text-base font-bold ${g.alim.toplam.kar >= 0 ? "bg-emerald-950/50 text-emerald-300" : "bg-rose-950/50 text-rose-300"}`}>GÜNÜN KÂRI (ALIM): {tl(g.alim.toplam.kar)} · KESİLEN: {tl(g.kesilen.toplam.kar)}</span>}
      </div>
      <div className="overflow-auto rounded-xl border border-slate-800 bg-slate-900">
        <table className="w-full text-[12px] text-slate-200">
          <thead><tr className="border-b border-slate-700 text-left text-slate-400">{["TIR", "YÖN", "DURUM", "ALIM CİRO", "NAVLUN", "ALIM KÂR", "KESİLEN CİRO", "KESİLEN KÂR", "KESİLMEDİ", ""].map((h) => <th key={h} className="px-2 py-1.5">{h}</th>)}</tr></thead>
          <tbody>
            {d?.tirs.length === 0 && <tr><td colSpan={10} className="px-2 py-6 text-center text-slate-500">BU TARİHTE TIR YOK</td></tr>}
            {d?.tirs.map((t) => (
              <tr key={t.id} data-testid={`gk-tir-${t.id}`} className="border-b border-slate-800">
                <td className="px-2 py-1"><Link to={`/tir-plan/${t.id}`} className="font-bold text-sky-300 hover:underline">{t.plate || t.id}</Link></td>
                <td className="px-2 py-1">{t.yon}</td><td className="px-2 py-1">{t.closed ? "KAPALI" : "AÇIK"}</td>
                <td className="px-2 py-1">{tl(t.alim.ciro)}</td><td className="px-2 py-1">{tl(t.alim.navlun)}</td>
                <td className={`px-2 py-1 font-bold ${t.alim.kar >= 0 ? "text-emerald-300" : "text-rose-300"}`}>{tl(t.alim.kar)}</td>
                <td className="px-2 py-1">{tl(t.kesilen.ciro)}</td>
                <td className={`px-2 py-1 font-bold ${t.kesilen.kar >= 0 ? "text-emerald-300" : "text-rose-300"}`}>{tl(t.kesilen.kar)}</td>
                <td className={`px-2 py-1 ${t.kesilmemis ? "font-bold text-amber-300" : ""}`}>{t.kesilmemis}</td>
                <td className="px-2 py-1"><button data-testid={`gk-excel-${t.id}`} onClick={() => downloadFile(`/tirs/${t.id}/sube-excel`, `tir_${t.id}_sube.xlsx`)} className="text-slate-400 hover:text-emerald-300"><Download className="h-4 w-4" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {g && d.tirs.length > 0 && <div><div className="mb-1 text-xs font-bold text-slate-400">TÜM TIR'LAR — ŞUBE / İL GENEL YEKÜN</div><TirSubeSummary subeler={g} /></div>}
    </div>
  );
}
